export default {
  default: () => import("/var/www/cellcom/production/frontend/src/layouts/default.vue")
}